import { useSidebarSearchState } from '@affine/core/components/sidebar-tree-search';
import { useMemo, useState } from 'react';

import { AnimatedNavigationPanelTreeChildren } from './animated-children';
import { NavigationPanelTreeContext } from './context';
import * as styles from './root.css';
import type { NodeOperation } from './types';

export const NavigationPanelTreeRoot = ({
  children,
  childrenOperations = [],
  placeholder,
}: {
  children?: React.ReactNode;
  childrenOperations?: NodeOperation[];
  className?: string;
  placeholder?: React.ReactNode;
}) => {
  const search = useSidebarSearchState();
  const [childCount, setChildCount] = useState(0);
  const contextValue = useMemo(() => {
    return {
      operations: childrenOperations,
      level: 0,
      registerChild: () => {
        setChildCount(c => c + 1);
        return () => setChildCount(c => c - 1);
      },
    };
  }, [childrenOperations]);

  return (
    <div>
      {/* For lastInGroup check, the placeholder must be placed above all children in the dom */}
      <div
        className={styles.placeholder}
        data-navigation-panel-tree-placeholder="true"
        data-empty={!search.active && childCount === 0}
      >
        {!search.active && childCount === 0 && placeholder}
      </div>
      <NavigationPanelTreeContext.Provider value={contextValue}>
        <AnimatedNavigationPanelTreeChildren animateEnteringHeight={false}>
          {children}
        </AnimatedNavigationPanelTreeChildren>
      </NavigationPanelTreeContext.Provider>
    </div>
  );
};
